module.exports = __webpack_public_path__ + "static/media/31068962_861247207410303_4734073893819476677_n.728cc8ce.jpg";